import { CSSObject } from '@chakra-ui/react';

export const BoxPageWrapper: CSSObject = {
  px: ['1', null, '4'],
  mx: ['2', null, null, 'unset'],
  minH: '50vh',

  borderBottomRadius: '6px',
};

export const BoxSectionWrapper: CSSObject = {
  mb: ['4'],
  px: ['2', 0],
  mx: ['-2', 0],

  _last: {
    a: {
      _last: { borderBottom: [0, 'unset'] },
    },
  },
};

export const BoxSportWrapper: CSSObject = {
  borderRadius: 'lg',
  boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.20)',
  border: 0,
  bg: 'white',
};

export const TextTitle: CSSObject = {
  color: 'beta.600',
  fontSize: 'sm',
  fontStyle: 'normal',
  fontWeight: 'bold',
  mb: '2',
  mt: '4',
};
export const TextName: CSSObject = {
  color: 'gray.700',
  fontSize: 'sm',
  fontStyle: 'normal',
  fontWeight: 'semibold',
};

export const LinkItem: CSSObject = {
  display: 'flex',
  px: '3',
  py: '2',
  gap: '2',
  alignItems: 'center',
  alignSelf: 'stretch',
  background: 'blackAlpha.50',
  borderBottom: '1px',
  borderBottomColor: 'gray.300',
  borderTop: 'none',
  mb: '1px',
  _hover: {
    background: 'blackAlpha.50',
  },
  _last: {
    mb: 0,
  },
};

export const IconSport: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  boxSize: '6',
  mr: '1',
  color: 'beta.200',
};

export const IconChevron: CSSObject = {
  boxSize: '5',
  p: '1',
  transition: '.3s ease-in-out',
  color: 'gray.700',

  _hover: {
    color: 'beta.800',
  },
};
